"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixPythagorasFeature = void 0;
const polygonize_1 = __importDefault(require("@turf/polygonize"));
function fixGeometry(geometry) {
    switch (geometry.type) {
        case 'LineString':
        case 'MultiLineString':
            return fixLineStringGeometry(geometry);
        case 'GeometryCollection':
            return Object.assign(Object.assign({}, geometry), { geometries: geometry.geometries.reduce((doneGeometries, geometry) => {
                    const fixed = fixGeometry(geometry);
                    if (fixed.type === 'GeometryCollection') {
                        return [...doneGeometries, ...fixed.geometries];
                    }
                    return [...doneGeometries, fixed];
                }, []) });
        default:
            return geometry;
    }
}
function fixLineStringGeometry(geometry) {
    try {
        return {
            type: 'GeometryCollection',
            geometries: polygonize_1.default(geometry)
                .features.map(feature => feature.geometry)
                .filter(function (x) {
                return !!x;
            }),
        };
    }
    catch (_a) {
        return geometry;
    }
}
function fixPythagorasFeature(immutableFeature) {
    var _a;
    const type = (_a = immutableFeature.properties) === null || _a === void 0 ? void 0 : _a.type;
    if (!['furniture.desk', 'furniture.chair'].includes(type)) {
        return immutableFeature;
    }
    const fixed = fixGeometry(immutableFeature.geometry);
    if (fixed === immutableFeature.geometry) {
        return immutableFeature;
    }
    else {
        return Object.assign(Object.assign({}, immutableFeature), { geometry: fixed });
    }
}
exports.fixPythagorasFeature = fixPythagorasFeature;
//# sourceMappingURL=fixPythagorasFeature.js.map